import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { RotateAnimatedView } from 'components/ucl/rotate-animated-view';
import { Box, BoxProps } from 'components/ui';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { getDesignToken } from 'styles/constants';

import { IDimensions, IOrientation, ISize } from './types';

const defaultMobileDimensions: IDimensions = {
  width: 8,
  height: 14,
};
const defaultDesktopDimensions: IDimensions = {
  width: 12,
  height: 21,
};

export const defaultSize: ISize = {
  mobile: defaultMobileDimensions,
  desktop: defaultDesktopDimensions,
};

export const defaultOrientation: IOrientation = {
  initialAngleDeg: 0,
  finalAngleDeg: 90,
};

const maxDimension = (dimension: IDimensions) => Math.max(dimension.height, dimension.width);

interface IArrowContainer {
  dimensionSizes: ISize;
}

const ArrowContainer = ({ dimensionSizes, style, ...props }: BoxProps & IArrowContainer) => {
  const isMobile = useIsMobileBreakpoint();
  const dimension = maxDimension(isMobile ? dimensionSizes.mobile : dimensionSizes.desktop);

  return (
    <Box
      {...props}
      style={[styles.arrowContainer, { height: dimension, width: dimension }, style]}
    />
  );
};

interface IDropdownArrow {
  open: boolean;
  disabled: boolean;
  size: ISize;
  orientation: IOrientation;
}

export const DropdownArrow: React.FC<React.PropsWithChildren<IDropdownArrow>> = ({
  open,
  disabled,
  orientation,
  size,
}) => {
  return (
    <ArrowContainer dimensionSizes={size}>
      <RotateAnimatedView
        isRotated={open}
        fromDeg={orientation.initialAngleDeg}
        toDeg={orientation.finalAngleDeg}
      >
        <Icon
          variant="next"
          color={getDesignToken(disabled ? 'icon-disabled' : 'icon-default')}
          aria-hidden
        />
      </RotateAnimatedView>
    </ArrowContainer>
  );
};

const styles = StyleSheet.create({
  arrowContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    flexShrink: 1,
    justifyContent: 'center',
  },
});
